import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },

  props: {
    activeTab: {
      type: String
    },
    brandImagesData: {
      type: Object
    }
  },

  data() {
    const prefs = this.brandImagesData
    return {
      preferences: {
        landing_bg: prefs.landing_bg,
        landing_logo: prefs.landing_logo,
        login_banner: prefs.login_banner
      },
      paths: prefs.paths,
      overlayAssets: prefs.overlay_assets,
      uploadingKey: null
    }
  },

  template: `
    <settings-container :activeTab="activeTab">
      <template slot="content">
        <div class="brand-images-settings">
          <div class="panel-card brand-images-hint">
            <div class="panel-card-body">
              <h4 class="brand-images-hint-title">点击下图进行编辑</h4>
              <ul class="brand-images-hint-list">
                <li>欢迎界面 Logo <small>（建议宽高比例 2:1, 750X1500px）</small></li>
                <li>欢迎界面背景图 <small>（建议宽高比例 1:1）</small></li>
                <li>绑定界面 banner <small>（建议宽高比例 2:1, 360X180px）</small></li>
              </ul>
              <p class="helper-text">（为了最佳效果请使用 PNG 格式的图片）</p>
            </div>
          </div>

          <div class="brand-images-settings-columns">
            <div class="brand-images-preview-panel">
              <div class="panel-card">
                <div class="panel-card-head">
                  <span class="panel-card-title">欢迎界面</span>
                </div>
                <div class="panel-card-body brand-images-preferences">
                  <div
                    class="landing-container"
                    :style="{ backgroundImage: bgUrl(preferences.landing_bg) }"
                  >
                    <label
                      class="landing-top"
                      :class="{ disabled: isUploading('landing_logo') }"
                      :style="{ backgroundImage: bgUrl(preferences.landing_logo) }"
                    >
                      <input
                        type="file"
                        accept=".png"
                        class="hidden-input"
                        :disabled="isUploading('landing_logo')"
                        @change="uploadImage($event, 'landing_logo')"
                      />
                      <img :src="overlayAssets.landing_top" alt="" />
                    </label>
                    <label
                      class="landing-bottom"
                      :class="{ disabled: isUploading('landing_bg') }"
                    >
                      <input
                        type="file"
                        accept=".png"
                        class="hidden-input"
                        :disabled="isUploading('landing_bg')"
                        @change="uploadImage($event, 'landing_bg')"
                      />
                      <img :src="overlayAssets.landing_bottom" alt="" />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="brand-images-preview-panel">
              <div class="panel-card">
                <div class="panel-card-head">
                  <span class="panel-card-title">绑定界面</span>
                </div>
                <div class="panel-card-body brand-images-preferences">
                  <div class="login-container">
                    <label
                      class="login-top"
                      :class="{ disabled: isUploading('login_banner') }"
                      :style="{ backgroundImage: bgUrl(preferences.login_banner) }"
                    >
                      <input
                        type="file"
                        accept=".png"
                        class="hidden-input"
                        :disabled="isUploading('login_banner')"
                        @change="uploadImage($event, 'login_banner')"
                      />
                      <img :src="overlayAssets.login_top" alt="" />
                    </label>
                    <div class="login-bottom">
                      <img :src="overlayAssets.login_bottom" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </settings-container>
  `,

  methods: {
    bgUrl(url) {
      return url ? `url(${url})` : 'none'
    },

    isUploading(key) {
      return this.uploadingKey === key
    },

    uploadImage(event, key) {
      const file = event.target.files[0]
      if (!file) return

      this.uploadingKey = key
      Skylark.Bridge.newAlertify('正在上传 ...', { type: 'success' })

      const image = new Skylark.Libs.Storage.Image(file)
      image.upload({
        success: (uploadUrl) => {
          const url = Skylark.Libs.Storage.publicImageUrl(uploadUrl)
          this.savePreference(key, url, event)
        },
        error: () => {
          Skylark.Bridge.newAlertify('上传失败', { type: 'danger' })
          this.uploadingKey = null
          event.target.value = ''
        }
      })
    },

    savePreference(key, url, event) {
      const payload = { brand_images_preferences: { [key]: url } }

      Skylark.Libs.Ajax.patch(this.paths.update, {
        data: payload,
        responseType: 'json',
        success: (data) => {
          this.preferences = {
            landing_bg: data.landing_bg,
            landing_logo: data.landing_logo,
            login_banner: data.login_banner
          }
          Skylark.Bridge.newAlertify('上传成功', { type: 'success' })
        },
        error: () => {
          Skylark.Bridge.newAlertify('上传失败', { type: 'danger' })
        },
        complete: () => {
          this.uploadingKey = null
          if (event && event.target) event.target.value = ''
        }
      })
    }
  }
})
